// extracted by mini-css-extract-plugin
module.exports = {"root":"AddTileButton_root__mOaMn","rootSmall":"AddTileButton_rootSmall__3bPVD"};